<template>
    <div>
        <b-input-group>
            <b-form-input :class="inputclass" :value="value.name" :placeholder="placeholder" readonly @click="trigger" @dragover="dragover" @dragleave="dragleave" @drop="drop"/>
            <b-input-group-append>
                <b-button class="btn-default btn-square py-0" v-show="!value.name" @click="trigger" @dragover="dragover" @dragleave="dragleave" @drop="drop">Procurar...</b-button>
                <b-button class="btn-default btn-square py-0" v-show="value.name" @click="remove">Remover</b-button>
            </b-input-group-append>
        </b-input-group>
        <div class="input-group" v-show="!theme">
            <input type="file" @change="handleFileChange" :accept="accept" ref="fileInput" :id="id" class="form-control"/>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            id: '',
            accept: '',
            value: {
                default: () => ({
                    name: ''
                }),
                name: ''
            },
            placeholder: {
                default: 'Nenhum arquivo selecionado'
            },
            theme: {
                type: Boolean,
                default: true
            },
            inputclass: {
                type: String,
                default: ''
            },
            progress: {
                type: Number,
                default: 0
            }
        },
        mounted() {
            try {
                if (typeof this.value === 'object' && this.value instanceof File) {
                    this.$refs.fileInput.files = this.fileListItems([this.value])
                }
            } catch (e) {
                console.error(e)
            }
        },
        methods: {
            fileListItems(files) {
                let b = new ClipboardEvent("").clipboardData || new DataTransfer()
                for (let i = 0, len = files.length; i < len; i++) {
                    b.items.add(files[i])
                }
                return b.files
            },
            trigger() {
                if (this.value.name !== '') {
                    return false;
                }
                this.$refs.fileInput.click()
            },
            handleFileChange(e) {
                if (e.target.files[0] === undefined) {
                    this.$emit('remove')
                } else {
                    this.$emit('input', e.target.files[0])
                }
            },
            remove() {
                this.$refs.fileInput.name = ''
                this.$refs.fileInput.value = null
                this.$emit('remove')
            },
            dragover(e) {
                e.preventDefault();
            },
            dragleave(e) {
            },
            drop(e) {
                e.preventDefault();
                if (this.value.name !== '') {
                    return false;
                }
                this.$refs.fileInput.files = e.dataTransfer.files
                this.$emit('input', this.$refs.fileInput.files[0])
            }
        },
        watch: {
            'value.nome'(newvalue) {
                this.value.name = newvalue
            }
        }
    }
</script>
